let instances = [];

class CheckboxReset {
    /**
     * Binding our event listener to the reset button.
     *
     * @param {HTMLElement} element
     */
    constructor(element) {
        this.element = element;
        this.resetButton = this.element.querySelector(".btn--reset");
        this.checkboxes = this.element.querySelectorAll("input[type=checkbox]");

        this.bindEvents();
    }

    /**
     * Adds on click event listener.
     *
     * @return {void}
     */
    bindEvents() {
        this.resetButton.addEventListener("click", () => {
            this.checkboxes.forEach((checkbox) => {
                checkbox.checked = false; // eslint-disable-line no-param-reassign

                const event = new Event("change");

                checkbox.dispatchEvent(event);
            });
        });
    }
}

export default {
    init: (element) => {
        instances.push(new CheckboxReset(element));
    },

    destroy: () => {
        instances.forEach((instance) => instance.unbindEvents());
        instances = [];
    },
};
